// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"184":"ef115ad6","681":"f8c9b1bc"}[chunkId] + ".js";
};